// extracted by mini-css-extract-plugin
export var darkMode = "_11-0";